<template>
  <!-- Shared deliverable header: every printable view (weekly rotation,
       holiday agreement / at-a-glance / year table, year calendar) opens
       with the same block — gold rule, title, parties. No logo up top and
       no generated-on date: these pages are attached as schedules to legal
       agreements, so the face of the document stays plain (a letterhead
       reads as Divii's document; a print date invites "which version
       governs?" arguments). The Divii logo appears instead as a small
       print-only footer, fixed bottom-right so it repeats on every page. -->
  <header class="print-header" :class="{ 'ph-print-only': printOnly }">
    <div class="ph-row">
      <div class="ph-titles">
        <h1 class="ph-title">{{ title }}</h1>
        <p class="ph-parties">
          Between <strong>{{ partyAName || 'Party A' }}</strong> and <strong>{{ partyBName || 'Party B' }}</strong>
        </p>
        <p v-if="subtitle" class="ph-subtitle">{{ subtitle }}</p>
      </div>
    </div>
    <img class="ph-footer-logo" :src="logo" alt="Divii" width="66" />
  </header>
</template>

<script>
// Use the bundled asset rather than a copy in public/ — it is the same logo the
// rest of the app imports, and the SVG is sharper than a PNG when printed.
import logo from '@/assets/Divii-Logo-Primary.svg'

export default {
  name: 'PrintHeader',
  data() {
    return { logo }
  },
  props: {
    title: { type: String, required: true },
    partyAName: { type: String, default: '' },
    partyBName: { type: String, default: '' },
    // Optional context line under the parties: jurisdiction, rotation
    // description, etc. Never a date.
    subtitle: { type: String, default: '' },
    // When true the header only appears in print — for views whose screen
    // chrome (banner, tab bar) already names the page.
    printOnly: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.print-header { margin: 0 0 0.85rem; }
.ph-row {
  display: flex;
  align-items: flex-start;
  gap: 0.85rem;
  border-left: 3px solid #f7a91b;
  padding-left: 0.7rem;
}
.ph-titles { flex-grow: 1; min-width: 0; }
.ph-title {
  margin: 0 0 0.15rem;
  font-size: 1.35rem;
  font-weight: 700;
  color: #34555f;
  letter-spacing: -0.01em;
}
.ph-parties {
  margin: 0;
  font-size: 0.85rem;
  color: #475569;
}
.ph-parties strong { color: #1e293b; font-weight: 600; }
.ph-subtitle {
  margin: 0.1rem 0 0;
  font-size: 0.78rem;
  color: #64748b;
}
.ph-print-only { display: none; }
/* Footer logo prints only: hidden on screen so the live tool stays
   uncluttered. */
.ph-footer-logo { display: none; }

@media print {
  .ph-print-only { display: block; }
  .print-header { margin-bottom: 0.5rem; }
  .ph-title { font-size: 1.1rem; }
  .ph-parties { font-size: 0.72rem; }
  .ph-subtitle { font-size: 0.66rem; }
  /* Small Divii mark, bottom-right of the printable area. position: fixed
     repeats it on every printed page. Kept small so it never collides with
     the last line of content on a full page. */
  .ph-footer-logo {
    display: block;
    position: fixed;
    bottom: 0;
    right: 0;
    width: 66px;
    height: auto;
  }
}
</style>
